import { useTranslation } from "react-i18next";
import type { ProjectStatus } from "@/api/types";
import { cn } from "@/lib/utils";

export type { ProjectStatus } from "@/api/types";

/** Driven by the --color-status-* tokens (src/design/tokens.css). */
export const STATUS_CLASSES: Record<ProjectStatus, string> = {
  requested: "bg-status-requested-bg text-status-requested-fg",
  discovery: "bg-status-discovery-bg text-status-discovery-fg",
  design: "bg-status-design-bg text-status-design-fg",
  build: "bg-status-build-bg text-status-build-fg",
  live: "bg-status-live-bg text-status-live-fg",
  paused: "bg-status-paused-bg text-status-paused-fg",
  closed: "bg-status-closed-bg text-status-closed-fg",
};

export function StatusPill({ status, className }: { status: ProjectStatus; className?: string }) {
  const { t } = useTranslation();
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 whitespace-nowrap rounded-pill px-3 py-0.5 text-sm font-medium",
        STATUS_CLASSES[status],
        className,
      )}
    >
      <span aria-hidden="true" className="h-1.5 w-1.5 rounded-full bg-current" />
      {t(`project.status.${status}`)}
    </span>
  );
}
